<template>
  <button
    type="button"
    class="inline-flex items-center rounded-md border border-transparent px-4 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary-60 focus:ring-offset-2"
    :class="{
      'focus:ring-blue bg-primary-40 text-neutral-100 shadow-sm hover:bg-primary-20': type === 'primary' && !disabled,
      'bg-neutral-90 text-neutral-100': type === 'primary' && disabled,
      'text-blue hover:text-blue-dark focus:ring-blue bg-white': type === 'secondary',
      'bg-danger-50 text-neutral-100 shadow-sm hover:bg-danger-30 focus:ring-danger-50': type === 'danger',
    }"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "primary",
      validator: function (value) {
        return ["primary", "secondary", "danger"].includes(value);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
